import React from 'react';

interface RobotMascotProps {
  style?: React.CSSProperties;
  className?: string;
}

export const RobotMascot: React.FC<RobotMascotProps> = ({
  style,
  className,
}) => (
  <svg
    viewBox="0 0 32 32"
    width="1em"
    height="1em"
    style={style}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <filter id="robot-glow">
        <feGaussianBlur stdDeviation="1" result="blur" />
        <feMerge>
          <feMergeNode in="blur" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
      <linearGradient id="robot-body" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#9ca3af" />
        <stop offset="100%" stopColor="#6b7280" />
      </linearGradient>
    </defs>
    {/* Antenna */}
    <line
      x1="16"
      y1="6"
      x2="16"
      y2="2"
      stroke="#6b7280"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <circle cx="16" cy="1.5" r="1.5" fill="#f97316" filter="url(#robot-glow)" />
    {/* Head */}
    <rect
      x="6"
      y="6"
      width="20"
      height="18"
      rx="4"
      fill="url(#robot-body)"
      stroke="#1f2937"
      strokeWidth="0.8"
    />
    {/* Eyes */}
    <circle cx="11.5" cy="14" r="2.5" fill="#1f2937" />
    <circle
      cx="11.5"
      cy="14"
      r="1.5"
      fill="#3b82f6"
      filter="url(#robot-glow)"
    />
    <circle cx="20.5" cy="14" r="2.5" fill="#1f2937" />
    <circle
      cx="20.5"
      cy="14"
      r="1.5"
      fill="#3b82f6"
      filter="url(#robot-glow)"
    />
    {/* Mouth vent */}
    <line
      x1="12"
      y1="20"
      x2="20"
      y2="20"
      stroke="#1f2937"
      strokeWidth="0.8"
      strokeLinecap="round"
    />
    <line
      x1="12"
      y1="21.8"
      x2="20"
      y2="21.8"
      stroke="#1f2937"
      strokeWidth="0.8"
      strokeLinecap="round"
    />
    <line
      x1="12"
      y1="23.6"
      x2="20"
      y2="23.6"
      stroke="#1f2937"
      strokeWidth="0.8"
      strokeLinecap="round"
    />
    {/* Ear bolts */}
    <circle cx="4" cy="15" r="1.5" fill="#f97316" />
    <circle cx="28" cy="15" r="1.5" fill="#f97316" />
    {/* Neck */}
    <rect
      x="13"
      y="24"
      width="6"
      height="3"
      rx="1"
      fill="#6b7280"
      stroke="#1f2937"
      strokeWidth="0.5"
    />
    {/* Feet */}
    <rect x="9" y="27" width="14" height="3" rx="1.5" fill="#1f2937" />
  </svg>
);
